export default "__VITE_ASSET__DBkIJ4cd__"